/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForGcpBillingSubAccount extends models.ServiceAccountNativeDetailsBaseForStructure {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForGcpBillingSubAccount");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForGcpBillingSubAccount.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForGcpBillingSubAccount>): ServiceAccountNativeDetailsForGcpBillingSubAccount {
        let obj = Object.assign(new ServiceAccountNativeDetailsForGcpBillingSubAccount(), model);
        ServiceAccountNativeDetailsForGcpBillingSubAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForGcpBillingSubAccount>): ServiceAccountNativeDetailsForGcpBillingSubAccount {
        if (!model) return null;
        return ServiceAccountNativeDetailsForGcpBillingSubAccount.newInstance(<ServiceAccountNativeDetailsForGcpBillingSubAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForGcpBillingSubAccount) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForGcpBillingSubAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForGcpBillingSubAccount): boolean {
        if (models.ServiceAccountNativeDetailsBaseForStructure.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForGcpBillingSubAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Billing Account Id
     */
    billing_account_id: string;

    /**
     * Organization Id
     */
    organization_id: string;

    /**
     * Organization Name
     */
    organization_name: string;

}
